import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const EFFECTIVE_DATE = 'August 7, 2026';
const CONTACT_EMAIL = 'craighalonen04@gmail.com';
const OPERATOR_NAME = 'Craig Halonen';

export default function PrivacyPolicy() {
  return (
    <div className="legal-container">
      <div className="legal-nav">
        <Link to="/login">&larr; Back</Link>
      </div>
      <div className="legal-card">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Effective date: {EFFECTIVE_DATE}</p>

        <p>
          This Privacy Policy describes how DesignsDesigns ERP ("the App," "we," "us") collects,
          uses, and protects information. The App is a quote-to-work-order management system
          built and operated by {OPERATOR_NAME} for use by a custom drapery and furniture
          workroom to manage its own customers, quotes, and work orders.
        </p>

        <h2>1. Who We Are</h2>
        <p>
          The App is operated by {OPERATOR_NAME}. For any question about this policy or your
          data, contact <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>

        <h2>2. Information We Collect</h2>
        <p>The App collects and stores the following categories of information:</p>
        <ul>
          <li>
            <strong>Account information</strong> — name, email address, and password (stored as
            a salted hash, never in plain text) for users of the App.
          </li>
          <li>
            <strong>Business records entered by users</strong> — customer names and contact
            details, addresses, quotes, quote line items, work orders, and related scheduling
            and pricing information entered in the course of operating the workroom.
          </li>
          <li>
            <strong>QuickBooks Online data</strong> — if a user connects the App to QuickBooks
            Online, we store OAuth access and refresh tokens issued by Intuit and use them to
            push finalized quotes to QuickBooks as Estimates and to read back their status
            (e.g. accepted/paid) when the user manually requests a sync. We do not access any
            other QuickBooks data, and syncing only happens when a user in the App explicitly
            triggers it — never automatically or in the background.
          </li>
          <li>
            <strong>Technical data</strong> — standard web server logs (IP address, timestamps,
            requests) generated by normal operation of the application server.
          </li>
        </ul>

        <h2>3. How We Use Information</h2>
        <p>Information is used solely to operate the App, specifically to:</p>
        <ul>
          <li>Authenticate users and maintain their session (via a JWT stored in the browser)</li>
          <li>Create, store, and display customers, quotes, and work orders</li>
          <li>Push finalized quotes to QuickBooks Online as Estimates, and reflect their status back into the App, only when a user initiates the sync</li>
          <li>Diagnose and fix technical problems with the App</li>
        </ul>
        <p>
          We do not sell, rent, or share personal information with third parties for
          advertising or marketing purposes. We do not use the data in the App to train
          machine learning models.
        </p>

        <h2>4. Data Sharing</h2>
        <p>
          We do not share stored data with third parties, except:
        </p>
        <ul>
          <li>With Intuit / QuickBooks Online, strictly to the extent necessary to create Estimates and read their status, and only when a user explicitly triggers a sync</li>
          <li>Where required to comply with a valid legal request (e.g. subpoena or court order)</li>
        </ul>

        <h2>5. Data Storage and Security</h2>
        <p>
          Data is stored in a PostgreSQL database on infrastructure operated by
          {` ${OPERATOR_NAME}`}. Access to the underlying server is restricted to the operator.
          Passwords are hashed before storage; authenticated requests use a signed JWT bearer
          token. Each customer/company using the App ("domain") has its data logically isolated
          from any other domain in the same database.
        </p>

        <h2>6. Data Retention</h2>
        <p>
          Business records (customers, quotes, work orders) are retained for as long as the
          account is active, since they form the operating business records of the workroom.
          A user or the operator may request deletion of an account and its associated data at
          any time by contacting <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>; QuickBooks
          OAuth tokens are deleted immediately upon disconnecting the QuickBooks integration.
        </p>

        <h2>7. Your Choices</h2>
        <p>
          You may disconnect the QuickBooks Online integration at any time from Settings, which
          revokes and deletes the stored OAuth tokens. You may request a copy of, correction to,
          or deletion of your personal information by contacting us at the email above.
        </p>

        <h2>8. Children's Privacy</h2>
        <p>
          The App is a business tool not directed at children, and we do not knowingly collect
          information from anyone under 16.
        </p>

        <h2>9. Changes to This Policy</h2>
        <p>
          If this policy changes, the updated version will be posted at this URL with a revised
          effective date above.
        </p>

        <h2>10. Contact</h2>
        <p>
          Questions about this Privacy Policy can be sent to{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
      </div>
    </div>
  );
}
